/**
 * One-time migration from "imprint-*" storage keys to "vidi-*".
 * Must run synchronously before React mounts so Zustand hydration
 * picks up the migrated data.
 */

const LOCAL_STORAGE_KEYS: [string, string][] = [
  ['imprint-store', 'vidi-store'],
  ['imprint-theme', 'vidi-theme'],
  ['imprint-offline-review-queue', 'vidi-offline-review-queue'],
  ['imprint-last-seen-version', 'vidi-last-seen-version'],
  ['imprint-immersion-prompted', 'vidi-immersion-prompted'],
  ['imprint-tooltips-seen', 'vidi-tooltips-seen'],
  ['imprint_admin_preview_mode', 'vidi_admin_preview_mode'],
];

const SESSION_STORAGE_KEYS: [string, string][] = [['imprint_attribution', 'vidi_attribution']];

function migrateCookie(oldName: string, newName: string): void {
  const match = document.cookie.match(new RegExp(`${oldName}=([^;]+)`));
  if (!match) return;

  const value = match[1];
  const maxAge = 365 * 24 * 60 * 60;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${newName}=${value}; max-age=${maxAge}; path=/; SameSite=Lax${secure}`;
  // Expire old cookie
  document.cookie = `${oldName}=; max-age=0; path=/`;
}

function migrateStorage(storage: Storage, pairs: [string, string][]): void {
  for (const [oldKey, newKey] of pairs) {
    if (storage.getItem(newKey) !== null) continue; // already migrated
    const value = storage.getItem(oldKey);
    if (value !== null) {
      storage.setItem(newKey, value);
      storage.removeItem(oldKey);
    }
  }
}

export function migrateBrandKeys(): void {
  if (localStorage.getItem('vidi-brand-migrated')) return;

  try {
    migrateStorage(localStorage, LOCAL_STORAGE_KEYS);
    migrateStorage(sessionStorage, SESSION_STORAGE_KEYS);
    migrateCookie('imprint_aid', 'vidi_aid');
    localStorage.setItem('vidi-brand-migrated', '1');
  } catch {
    // Storage access can fail in incognito/restricted contexts — skip silently
  }
}
